// extracted by mini-css-extract-plugin
export var divider = "_oo-0";
export var systemMessage = "_oo-1";